import { Component } from "react";

/* Poslední záchrana UI. Bez něj React při chybě v renderu odmountuje celý strom,
   `#root` zůstane prázdný a uživatel vidí jen černou plochu (výchozí téma je dark),
   která na nic nereaguje — přesně to hlásí klienti. Tady místo toho ukážeme,
   co se stalo, a dáme to zkopírovat na podporu. */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, stack: "", copied: false };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Do konzole vždy — je to jediná stopa, kterou po nás uživatel může poslat.
    console.error("[Proyekty] Neošetřená chyba UI:", error, info?.componentStack);
    this.setState({ stack: info?.componentStack || "" });
  }

  detail() {
    const e = this.state.error;
    return [
      `Chyba: ${e?.name || "Error"}: ${e?.message || String(e)}`,
      `Stránka: ${window.location.href}`,
      `Čas: ${new Date().toLocaleString("cs-CZ")}`,
      `Prohlížeč: ${navigator.userAgent}`,
      (e?.stack || "").split("\n").slice(1, 6).join("\n"),
      this.state.stack ? `Komponenty:${this.state.stack.split("\n").slice(0, 5).join("\n")}` : "",
    ].filter(Boolean).join("\n");
  }

  copy = async () => {
    try {
      await navigator.clipboard.writeText(this.detail());
      this.setState({ copied: true });
    } catch {
      this.setState({ copied: false });
    }
  };

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center p-4 bg-background text-foreground">
        <div className="w-full max-w-lg rounded-[20px] border border-border bg-card p-5 sm:p-6 space-y-4">
          <div className="space-y-1">
            <h1 className="text-xl sm:text-2xl font-bold tracking-tight">Něco se pokazilo</h1>
            <p className="text-sm text-muted-foreground">
              Stránku se nepodařilo zobrazit. Zkuste ji načíst znovu — vaše data jsou v pořádku,
              chyba je jen v zobrazení.
            </p>
          </div>
          <pre className="max-h-40 overflow-auto rounded-md bg-muted p-3 text-[11px] leading-relaxed whitespace-pre-wrap break-words select-all">
            {this.detail()}
          </pre>
          <div className="flex flex-col sm:flex-row gap-2 sm:justify-end">
            <button
              type="button"
              onClick={this.copy}
              className="w-full sm:w-auto h-11 px-4 rounded-md border border-border font-semibold text-sm hover:bg-muted transition-colors"
            >
              {this.state.copied ? "Zkopírováno" : "Kopírovat detail chyby"}
            </button>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="w-full sm:w-auto h-11 px-4 rounded-md bg-brand text-white font-bold text-sm hover:opacity-90 transition-opacity"
            >
              Načíst znovu
            </button>
          </div>
          <p className="text-xs text-muted-foreground">
            Když se to opakuje, pošlete prosím zkopírovaný text na podporu — je v něm přesná příčina.
          </p>
        </div>
      </div>
    );
  }
}
